export default {
  translation: {
    nav: {
      home: 'Startseite',
      trips: 'Reisen',
      aboutUs: 'Über uns',
      alerts: 'Benachrichtigungen',
      wishlist: 'Merkliste',
      language: 'Sprache',
      profile: 'Profil',
      settings: 'Einstellungen',
      signIn: 'Anmelden',
      signUp: 'Registrieren'
    },
    hero: {
      title: 'Entdecke Uganda',
      subtitle: 'und mehr',
      description: 'Entdecken Sie die Perle Afrikas mit erfahrenen lokalen Reiseführern. Unvergessliche Erlebnisse erwarten Sie in Ugandas atemberaubender Landschaft und lebendiger Kultur.',
      searchPlaceholder: 'Wohin möchten Sie reisen?',
      categories: {
        all: 'Alle',
        wildlife: 'Wildtiere',
        safari: 'Safari',
        cultural: 'Kultur',
        adventure: 'Abenteuer',
        birding: 'Vogelbeobachtung'
      }
    },
    common: {
      from: 'ab',
      reviews: 'Bewertungen',
      viewMore: 'Mehr anzeigen',
      book: 'Buchen',
      seeAll: 'Alle anzeigen',
      loading: 'Lädt...'
    }
  }
};